import { inject } from 'inversify';

import { service } from '@/decorators/service';
import { SignalrListener, SignalrMessage } from '@/decorators/signalr';
import { Vehicle } from '@/entities/Vehicle';
import { Logger } from '@/services/Logger';
import { Signalr } from '@/services/signalr/Signalr';
import { VehicleStore } from '@/stores/VehicleStore';
import { orderByField } from '@/utils/orderBy';
import type { IVehicleInfo } from '~/api/IVehicleInfo';
import type { IDispatchMessage } from '~/api/messages/IDispatchMessage';
import { IVehicleRespMsg } from '~/api/messages/IVehicleRespMsg';
import type { IVehiclesRespMsg } from '~/api/messages/IVehiclesRespMsg';

@SignalrListener
@service(VehicleManager)
export class VehicleManager {
  @inject(Logger) protected logger: Logger;
  @inject(Signalr) protected signalr: Signalr;
  @inject(VehicleStore) protected vehicleStore: VehicleStore;

  // Expose current vehicles
  get all(): Vehicle[] {
    const vehicles = this.vehicleStore.all();
    return orderByField(vehicles, this.vehicleStore.valueKey);
  }

  find(id: string | number) {
    return this.vehicleStore.find(id);
  }

  update(vehicle: IVehicleInfo) {
    this.vehicleStore.update(vehicle);
  }

  // Handle list response (plural)
  @SignalrMessage('VehiclesRespMsg', 'VehiclesMsg')
  async onVehiclesRespMsg(vehiclesMsg: IVehiclesRespMsg & IDispatchMessage) {
    this.vehicleStore.batchUpdate(vehiclesMsg.vehicles);
  }

  @SignalrMessage('VehicleRespMsg')
  async onVehicleRespMsg(vehicleMsg: IVehicleRespMsg & IDispatchMessage) {
    this.vehicleStore.batchUpdate(vehicleMsg.vehicles);
  }
}
